export const answerCampaignQuestionOptions = {
  props: ({mutate, ownProps: {store}}) => ({
    answerCampaignQuestionMutation: variables =>
      mutate({
        variables
      })
  })
};
